import { all, fork } from "redux-saga/effects";

import DeviceSaga from "./devices/saga";
import watchArticle from "./sagas/articles";
import watchAuth from "./sagas/auth";
import watchGraph from "./sagas/graph";

export default function* rootSaga() {
  yield all([fork(DeviceSaga), watchAuth(), watchGraph(), watchArticle()]);
}
